import { render, staticRenderFns } from "./SectorSubmitBar.vue?vue&type=template&id=5faa791e&"
import script from "./SectorSubmitBar.vue?vue&type=script&lang=js&"
export * from "./SectorSubmitBar.vue?vue&type=script&lang=js&"
import style0 from "./SectorSubmitBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports